<template>
  <div class="order-detail">
    <a-spin :spinning="loading">
    <div class="title goback_btn">
        <div><span class="label">委托实验室：</span><span class="text">{{formObj.labName}}</span></div>
        <a-button @click="goBack" type="link"><a-icon type="rollback" />返回</a-button>
    </div>
    <div class="til">订单进程记录</div>
    <div class="swiper-box">
        <a-icon type="caret-left" v-show="showLeftIcon" @click="leftClick" style="font-size: 52px;position: absolute;left: 0px;top: 50%;transform: translateY(-50%);color: #409eff;"/>
        <a-icon type="caret-right" v-show="showRightIcon" @click="rightClick" style="font-size: 52px;position: absolute;right: 0px;top: 50%;transform: translateY(-50%);color: #409eff;"/> 
        <div class="time-box" id="time-box">
            <div class="main-box" id="main-box">
                <div class="timeline-list" v-for="(i, index) in timeList" :key="index">
                    <div class="time-icon">
                        <div class="circle" :style="'background-color:' + i.color"></div>
                        <div class="line"></div>
                    </div>
                    <div class="info-box">
                        <p v-html="i.stateDesc"></p>
                        <p class="time" v-if="i.createTime">{{i.createTime | formatDateTime}}</p>
                        <p v-for="(s, index) in i.content" :key="index + 'h'">{{s}}</p>
                        <p v-if="i.reportAnnex.length > 0"><span>报告附件：</span></p>
                        <p v-for="(a, index) in i.reportAnnex" :key="index + 'i'">
                            <a target="_blank" :href="wordPreviewUrl(a.inlineUrl)" >{{a.fileName}}</a>
                        </p>
                        <p v-if="i.quotationAnnex.length>0"><span>报价单附件：</span></p>
                        <p v-for="(b, index) in i.quotationAnnex" :key="index + 'j'">
                            <a target="_blank" :href="wordPreviewUrl(b.inlineUrl)" >{{b.fileName}}</a>
                        </p>
                        <p v-if="i.labOrderAnnex.length > 0"><span>委托单附件：</span></p>
                        <p v-for="(c, index) in i.labOrderAnnex" :key="index + 'k'">
                            <a target="_blank" :href="wordPreviewUrl(c.inlineUrl)" >{{c.fileName}}</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-if="type == 1">
        <div class="til">委托信息</div>
        <div class="box info-box">
            <p><span class="name">公司名称：</span><span class="model">{{formObj.companyName}}</span></p>
            <p><span class="name">公司地址：</span><span class="model">{{formObj.companyAddress}}</span></p>
            <p><span class="name">邮寄地址：</span><span class="model">{{formObj.mailingAddress}}</span></p>
            <p><span class="name">联系人/电话：</span><span class="model">{{formObj.contactPerson}} {{formObj.contactPhone}}</span></p>
            <p><span class="name">其他联系方式：</span><span class="model"><span>QQ：{{formObj.qqNumber}}</span> <span>微信： {{formObj.wechatNumber}}</span> <span>邮箱：{{formObj.email}}</span></span></p>
        </div>
        <div class="til">缴费信息</div>
        <div class="box sample-info">
            <p><span class="name">缴费单位名称：</span><span class="model">{{formObj.paymentCompany}}</span></p>
        </div>
        <div class="til">样品信息</div>
        <div class="box sample-info">
            <p><span class="name">制造商：</span><span class="model">{{formObj.manufacturerName}}</span></p>
            <p><span class="name">制造商地址：</span><span class="model">{{formObj.manufacturerAddress}}</span></p>
            <p><span class="name">生产商：</span><span class="model">{{formObj.factoryName}}</span></p>
            <p><span class="name">生产商地址：</span><span class="model">{{formObj.factoryAddress}}</span></p>
        </div>
        <div class="til">检测要求</div>
        <div class="box">
            <div class="table">
                <a-table
                    :columns="testSamples"
                    :dataSource="formObj.testSamples"
                    :pagination="false"
                    @expandRowByClick="true"
                    :rowKey="record => record.id"
                    :locale="{
                    emptyText: '暂无数据'
                    }">
                </a-table>
            </div>
        </div>
        <div class="til">报告要求</div>
        <div class="box report-info">
            <p><span class="name">报告语言：</span><span class="model">{{formObj.reportLanguage | reportLanguage}}</span></p>
            <p><span class="name">报告交付方式：</span><span class="model">{{formObj.deliveryType | deliveryType}}</span></p>
            <p><span class="name">报告份数：</span><span class="model">{{formObj.reportNum}}</span></p>
            <p><span class="name">是否加急：</span><span class="model">{{formObj.deadlineType | deadlineType}}</span></p>
            <p><span class="name">希望完成日期：</span><span class="model" v-if="formObj.expectTime">{{formObj.expectTime | formatDate}}</span></p>
        </div>
        <div class="box">
            <p><span class="name">备注：</span><span class="model">{{formObj.remark}}</span></p>
        </div>
    </div>
    <div v-else>
        <div class="til">检测认证信息</div>
        <div class="dec-info-box">
            <div class="row-wrap">
                <p class="info-item"><span class="name">委托单位名称：</span><span class="model">{{formObj.companyName}}</span></p>
                <p v-if="type === '2'" class="info-item"><span class="name">认证申请编号：</span><span class="model">{{formObj.applyNumber}}</span></p>
                <p v-else class="info-item"><span class="name">委托申请编号：</span><span class="model">{{formObj.orderNumber}}</span></p>
            </div>
            <div class="row-wrap">
                <p class="info-item"><span class="name">缴费单位名称：</span><span class="model">{{formObj.paymentCompany}}</span></p>
                <p class="info-item"><span class="name">希望完成日期：</span><span class="model">{{formObj.expectTime | formatDate}}</span></p>
            </div>
            <div class="row-wrap">
                <p class="info-item"><span class="name">产品名称：</span><span class="model">{{formObj.productName}}</span></p>
            </div>
            <div class="row-wrap">
                <p class="info-item"><span class="name">备注：</span><span class="model">{{formObj.remark}}</span></p>
            </div>
        </div>
        <div class="file-box">
            <span class="name">认证申请附件：</span>
            <ul class="file-list">
                <template v-for="(s, index) in photoList">
                    <li class="file" :key="index" @click="preview(s.inlineUrl)">
                        <span class="file-name">
                            <a-icon type="file" /> {{s.fileName}} <a-icon type="eye" />
                        </span>
                    </li>
                </template>
            </ul>
        </div>
    </div>
    </a-spin>
  </div>
</template>

<script>
import { getEnterpriseDetail } from '@/api/entrust'
import {formatDate} from '@/utils/date';

const align = 'center'
export default {
  components: {},
  data() {
    return {
        formId: '',
        cascaderOptions: [],
        formObj: {},
        type: undefined, // 订单类型，'1' 表示商业检测，'2' 表示认证检测，'3' 表示商业检测（已委托）
        maxClickNum: 0, // 最大点击次数
        lastLeft: 0, // 上次滑动距离
        clickNum: 0, // 点击次数
        showRightIcon: false, // 是否显示右箭头
        timeList: [],
        photoList: [],
        testSamples: [
        {
          title: "序号",
          dataIndex: 'no',
          align,
          width: 60
        },
        {
          title: "样品名称",
          dataIndex: 'sampleName',
          align,
          width: 200
        },
        {
          title: "样品数量",
          dataIndex: 'sampleNum',
          align,
          width: 80
        },
        {
          title: "检测要求",
          dataIndex: 'testingRequirements',
          align,
          width: 200
        },
      ],
      loading: true
    };
  },
  created() {
      let query = this.$route.query;
      if (query.id) {
        this.formId = query.id;
        this.getEnterpriseDetail(this.formId);
    }
  },
  mounted() {
    
  },
  computed: {
    showLeftIcon() {
      return this.clickNum > 0
    }
  },
  filters: {
    formatDate(time) {
      var date = new Date(time);
      return formatDate(date, "yyyy-MM-dd");
    },
    formatDateTime(time) {
      var date = new Date(time);
      return formatDate(date, "yyyy-MM-dd hh:mm:ss");
    },
    reportLanguage(val) {
        switch(val) {
            case '0':
                return '中文报告'
                break;
            case '1':
                return '英文报告'
                break;
            case '2':
                return '中英文对照报告'
                break;
            default:
                return '-'
        } 
    },
    deliveryType(val) {
        switch(val) {
            case '0':
                return '电子版'
                break;
            case '1':
                return '纸质版'
                break;
            default:
                return '-'
        } 
    },
    deadlineType(val) {
        switch(val) {
            case '0':
                return '不加急'
                break;
            case '1':
                return '加急'
                break;
            default:
                return '-'
        } 
    },
  },
  methods: {
    // 预览 word 和 PDF 时
    wordPreviewUrl(url) {
      if (url && url[0] === '/') {
        return window.location.origin + url;
      } else {
        return url;
      }
    },
    goBack() {
        this.$router.go(-1);
    },
    preview(url){
        window.open(this.wordPreviewUrl(url));
    },
    handleCancel() {
        this.previewVisible = false;
    },
    rightClick() {
      if (this.clickNum < this.timeList.length - 1) {
        let width = document.querySelectorAll('.timeline-list')[this.clickNum].offsetWidth * 2
        let lastItemOffsetLeft = document.getElementsByClassName('timeline-list')[this.timeList.length - 1].offsetLeft
        const lookWidth = document.getElementById('time-box').clientWidth
        if (lastItemOffsetLeft > lookWidth) {
          document.getElementsByClassName('main-box')[0].style.marginLeft = `${-width + this.lastLeft}px`
          this.lastLeft = -width + this.lastLeft
          this.clickNum += 1
          this.maxClickNum = this.clickNum
        }
        this.showRightIcon = lastItemOffsetLeft > lookWidth + width
      }
    },
    leftClick() {
      if (this.clickNum > 0) {
        let width = document.querySelectorAll('.timeline-list')[this.clickNum - 1].offsetWidth * 2
        document.getElementsByClassName('main-box')[0].style.marginLeft = `${this.lastLeft + width + 130}px`
        this.lastLeft = width + this.lastLeft
        this.clickNum--
        if (this.clickNum < this.maxClickNum) {
          this.showRightIcon = true
        }
      }
    },
    getEnterpriseDetail(id) {
        getEnterpriseDetail(id)
            .then(res => {
                this.formObj = res;
                this.type = res.type;
                this.timeList = res.histories;
                const lookWidth = document.getElementById('time-box').clientWidth;
                const defaultWidth = 270;
                let maxWidth = 0;
                this.photoList = res.authTestingAnnex;
                if (this.timeList.length > 0) {
                    maxWidth = defaultWidth * this.timeList.length - 1 - 130;
                }
                if (maxWidth > lookWidth) {
                    this.showRightIcon = true;
                } else {
                    this.showRightIcon = false;
                }
                setTimeout(() => {
                    this.loading = false;
                }, 500)
            })
            .catch(error => {
                console.log(error);
            })
    },
  },
  watch: {
   
  },
};
</script>
<style lang="less">
.red {
    color: red;
}
</style>
<style lang="less" scoped>
    /deep/.ant-modal-close-x {
        width: 30px;
        height: 30px;
        line-height: 30px;
    }
    /deep/.ant-table {
        font-size: 12px;
    }
    .order-detail {
        width: 100%;
        min-height: 100%;
        background-color: #fff;
        padding: 30px 200px;
        margin: 0 auto;
        box-sizing: border-box;
        .hidden {
            visibility: hidden;
            // display: none;
        }
        .title {
            .label {
                color: #999;
                font-size: 16px;
            }
            .text {
                font-size: 18px;
                font-weight: 700;
                color: #333;
            }
        }
        .goback_btn {
            display: flex;
            justify-content: space-between;
        }
        .til {
            background-color: #E7F4FF;
            color: #333;
            height: 30px;
            line-height: 30px;
            border-radius: 10px;
            margin: 15px 0;
            padding: 0 30px;
            box-sizing: border-box;
            font-size: 16px;
            // opacity: .7;
        }
        .swiper-box {
            position: relative;
            padding: 20px 0;
            .time-box {
                width: 90%;
                overflow: hidden;
                transition: all 0.5s;
                box-sizing: border-box;
                margin: 0 auto;
                .main-box {
                    min-width: 100%;
                    margin-left: 130px;
                    box-sizing: border-box;
                    display: flex;
                    flex-wrap: nowrap;
                    // align-items: center;
                    transition: all 0.5s;
                    .timeline-list {
                        width: 270px;
                        // float: left;
                        // background-color: pink;
                        .info-box {
                            width: 100%;
                            text-align: center;
                            margin-top: 10px;
                            p {
                                width: 80%;
                                overflow : hidden;
                                // text-overflow: ellipsis;
                                // display: -webkit-box;
                                // -webkit-line-clamp: 4;
                                // -webkit-box-orient: vertical;
                                word-break: break-all;
                                margin-bottom: 5px;
                                .red {
                                    color: red;
                                }
                            }
                            margin-bottom: 10px;
                            margin-left: -35%;
                            .time {
                                color: #999;
                                font-size: 12px;
                            }
                        }
                        .time-icon {
                            width: 100%;
                            display: flex;
                            align-items: center;
                            .circle {
                                width: 20px;
                                height: 20px;
                                border-radius: 20px;
                                background-color: green;
                            }
                            .line {
                                width: 250px;
                                height: 1px;
                                background-color: #ccc;
                            }
                        }
                        
                    }
                    // .timeline-list:nth-child(2n) {
                    //     .info-box {
                    //         margin-top: 10px;
                    //     }
                    // }
                    .timeline-list:last-child {
                        .line {
                            visibility: hidden;
                        }
                    }
                }
            }
        }
        .box {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            // justify-content: space-between;
            p {
                display: flex;
                margin-bottom: 10px;
                width: 100%;
                .name {
                    display: block;
                    width: 120px;
                    text-align: right;
                }
                .model {
                    display: block;
                    width: ~"calc(100% - 120px)";
                    color: #999;
                    span {
                        margin-right: 15px;
                    }
                }
            }
            .table {
                width: 100%;
            }
        }
        .dec-info-box {
            .row-wrap {
                display: flex;
                .info-item {
                    margin-bottom: 10px;
                    flex: 1;
                    .name {
                        display: inline-block;
                        width: 120px;
                        text-align: right;
                    }
                    .model {
                        display: inline-block;
                        width: ~"calc(100% - 120px)";
                        color: #999;
                        span {
                            margin-right: 15px;
                        }
                    }
                }
            }
        }
        .file-box {
            display: flex;
            .name {
                width: 120px;
                text-align: right;
            }
            .file-list {
                flex: 1;
                .file {
                    line-height: 25px;
                    color: #606266;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    transition: all .3s;
                    &:hover {
                        .file-name{
                            color: #409eff;
                            cursor: pointer;
                            background-color: #f5f7fa;
                            border-radius: 3px;
                        }
                    }
                    .file-name {
                        display: inline-block;
                        line-height: inherit;
                        padding: 0 5px;
                        .anticon-eye {
                            margin-left: 15px;
                        }
                    }
                }
            }
        }
        .info-box {
            p {
                width: 100%;
            }
        }
        .sample-info {
            p {
                width: 50%;
            }
        }
        .report-info {
            justify-content: flex-start;
             p {
                width: 33%;
            }
        }
        .btn-area {
            margin-top: 50px;
            text-align: center;
        }
    }
</style>
